import { createIcon } from '../createIcon';

export const IciclesIconConfig = {
  name: 'IciclesIcon',
  height: 512,
  width: 512,
  svgPath: 'M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const IciclesIcon = createIcon(IciclesIconConfig);

export default IciclesIcon;